/**
 * Concatenação de classes utilitárias.
 *
 * Substitui `clsx` sem adicionar dependência (§ regra de não instalar pacotes).
 * Não faz merge de conflitos como o `tailwind-merge`: se o consumidor passar
 * `className` com uma classe que colide com a da variante, quem vence é a ordem
 * da folha de estilo do Tailwind, não a ordem do atributo. Por isso as variantes
 * dos componentes são fechadas — `className` serve para layout (margem, largura,
 * posicionamento), não para repintar o componente.
 */
export type ValorDeClasse = string | false | null | undefined;

export function juntarClasses(...valores: ValorDeClasse[]): string {
  return valores
    .filter((valor): valor is string => typeof valor === 'string' && valor !== '')
    .join(' ');
}
